import HttpRequest from '@/api/axios/fetch.axios'
export * from '@/api/axios/fetch.axios'
export default new HttpRequest()
